export { default as validateEmail } from "./validateEmail";
export { default as validateZipCode } from "./validateZipCode";
export { default as maskEmail } from "./maskEmail";
export { default as maskPhone } from "./maskPhone";
export { default as useQuery } from "./useQuery";
export { default as isPatientMinor } from "./isPatientMinor";
export {
  getTimeZones,
  getTranslatedTimeZoneUserValue,
  getTimeZoneShort,
  getUserTimezonesValues,
  getBrowserTimezonesValues,
  getUserTimezoneValue,
  getBrowserTimezoneValue,
  getDateTimeWithTimeZoneDelta,
  getTimeZoneFormat,
  getTimezoneDeltaInHours,
  formatToUTCO,
  getTimeSlot,
  getNameTimezones,
  TimeZoneType,
  getLocalForTimezone,
  getFormattedMaintenanceDateTime,
} from "./timeZone";
export {
  isConnectPortal,
  isOrganHealthPortal,
  isOncologyPortal,
} from "./portals";
export { openNewWindow, redirectTo } from "./common";
export { convertDate, convertSampleCollectionDate } from "./convertDate";
export { getLastSunday } from "./getSunday";
export { getDisabledSlots } from "./getDisabledSlots";
export { snakeCaseToCapitalizedWords } from "./snakeCaseToCapitalizedWords";
export { capitalizeFirstLetter } from "./capitalizeFirstLetter";
export { verifyCodeLength } from "./verifyCodeLength";
export { getProfileCredentials } from "./getProfileCredentials";
export { isValidZip, isPuertoRicoZipCode } from "./isValidZip";
export { getListOfAddresses } from "./getListOfAddresses";
export { showAppointmentDetails } from "./showAppointmentDetails";
export { showAddressSection } from "./showAddressSection";
export { getPhoneValidationErrorMessage } from "./getPhoneValidationErrorMessage";
export {
  formatPhoneNumberInput,
  formatPastedPhoneNumber,
  stripPhoneFormatting,
} from "./phoneNumberInput";
export { getTestCardLinkAriaLabel } from "./getTestCardLinkAriaLabel";
export {
  getCommercialInsurancePriceEstimation,
  getPriceEstimation,
} from "./getPriceEstimation";
export { getEstimatedResultsDeliveryDate } from "./getEstimatedResultsDeliveryDate";
export {
  isComboOrder,
  isHorizonOrder,
  isPanoramaOrder,
  getTestTypeForHeap,
} from "./orderHelpers";
export {
  SUPPLEMENTAL_VIDEO_NAMES,
  getHeapVideoContentType,
} from "./getHeapVideoContentType";
export { getSalivaTestCards } from "./getSalivaTestCards";
export { getPaymentInfoDto } from "./getPaymentInfoDto";
export {
  getTestNameForHeap,
  getTestNameForHeapByTestType,
} from "./getTestNameForHeap";
export { getAddressAsString } from "./getAddressAsString";
export { isValidLanguageValue } from "./isValidLanguageValue";
export { generatePassword } from "./generatePassword";
export { formatProvinceCode } from "./formatProvinceCode";

export {
  isFirstMultipleStep,
  isSecondMultipleStep,
  isCommercialOrGovernmentInsuranceFirst,
  isCommercialOrGovernmentInsuranceSecond,
} from "./isMultipleStep";

export { getPaymentMethodInfoSubStepsData } from "./getPaymentMethodInfoSubStepsData";
export { getProfileFullName } from "./profile";
export { weekDayFormatter } from "./weekDayFormatter";
export { getFormattedLocalizeDate } from "./getFormattedLocalizeDate";

export { getParamsForHeapMPApptFailureEvent } from "./getParamsForHeapMPApptFailureEvent";
export { getFormattedToUTCDate } from "./getFormattedToUTCDate";

export { getReadableComboOrderTestTypesList } from "./getReadableComboOrderTestTypes";
export { getReadableComboOrderTestTypesString } from "./getReadableComboOrderTestTypesString";

export { getPdfViewHeapHandlers } from "./getPdfViewHeapHandlers";
export { isFirstResultView } from "./isFirstResultView";

export * from "./heapHelper";
export * from "./dobHelper";
export {
  setOktaTokens,
  clearOktaAuthStorage,
  clearOktaSessionWithLogoutEndpoint,
  OKTA_TRANSACTION_STORAGE_KEY,
  OKTA_CACHE_STORAGE_KEY,
} from "./oktaHelper";
export type { SetOktaTokensParams } from "./oktaHelper";
export {
  getInitialMode,
  clearOtpStorage,
  OTP_EMAIL_STORAGE_KEY,
  OTP_STATE_HANDLE_STORAGE_KEY,
  OTP_VERIFICATION_MODE_KEY,
  setOtpEmailStorage,
  setOtpStateHandleStorage,
  setOtpVerificationModeStorage,
} from "./otpStorageKeys";
export {
  createOtpOktaAuth,
  getOtpTiming,
  resolveOtpErrorMessage,
  startOtpIdxFlow,
  verifyOtpCode,
} from "./otpFlow";
export {
  hasExpiredErrorKey,
  isUserIdNotFoundError,
  getOtpStateHandle,
} from "./otpHelper";
export type { OtpTransaction } from "./otpFlow";
export {
  ORGANIC_SIGN_UP_TOTAL_STEPS,
  TOKENIZED_SIGN_UP_TOTAL_STEPS,
  SIGN_UP_ACTIVATION_STEP,
  getSignUpFlowProgressValue,
  getOrganicSetupProfileDisplayStep,
} from "./signUpFlowSteps";
